import { Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";
import { Item } from "ionic-angular";
import { PassAlertFailFieldNode } from "./pass-alert-fail-control-node.model";

@Component({
    selector: "passalertfail-node",
    template: `
        <div class="item-inner">
            <div class="input-wrapper">
                <ion-grid>
                    <ion-row>
                        <ion-col>
                            <ion-item>
                                <button
                                    ion-button
                                    item-content
                                    item-start
                                    small
                                    *ngIf="hasChildren()"
                                    (click)="onToggleChildren()"
                                >
                                    <ion-icon name="add-circle" *ngIf="!showChildren"></ion-icon>
                                    <ion-icon name="remove-circle" *ngIf="showChildren"></ion-icon>
                                </button>
                                <ion-label *ngIf="hasChildren()">
                                    <h1>{{ node.title }}</h1>
                                </ion-label>
                                <ion-label *ngIf="!hasChildren()">
                                    {{ node.title }}
                                </ion-label>
                            </ion-item>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="!hasChildren()">
                        <ion-col>
                            <passalertfail-item
                                [formControl]="node.getFormControl()"
                                (changes)="onItemChange($event)"
                            ></passalertfail-item>
                        </ion-col>
                    </ion-row>
                    <ion-row *ngIf="hasChildren() && showChildren" ngClass="child-rows">
                        <passalertfail-node
                            *ngFor="let child of node.children"
                            [node]="child"
                            (onChange)="onNodeChange($event)"
                        ></passalertfail-node>
                    </ion-row>
                </ion-grid>
            </div>
        </div>
    `
})
export class PassAlertFailControlNodeComponent extends Item {
    @Input() node: PassAlertFailFieldNode;
    @Output() onChange: EventEmitter<any> = new EventEmitter();

    @HostBinding("class") classes = "item item-block item-md";
    @HostBinding("class.has-children") _hasChildren: boolean;
    @HostBinding("class.is-header") _isHeader: boolean;

    showChildren = false;

    ngOnInit(): void {
        this._hasChildren = this.hasChildren();
        this._isHeader = this.node.type === "header";
    }

    hasChildren(): boolean {
        return this.node.children.length > 0;
    }

    onToggleChildren(): void {
        this.showChildren = !this.showChildren;
    }

    onItemChange($event): void {
        this.onChange.emit($event);
    }

    onNodeChange($event): void {
        this.onChange.emit($event);
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/pass-alert-fail/form/pass-alert-fail-control-node.component.ts